import { render, staticRenderFns } from "./ShowPermissions.vue?vue&type=template&id=b94c4d4c"
import script from "./ShowPermissions.vue?vue&type=script&lang=js"
export * from "./ShowPermissions.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports